<template>
	<aside>
		<router-link active-class="active-link" class="btn btn-primary" to="/" data-cy="sb_logo" id="logo"
			@click.prevent="handleLinkClick">
			<logo_icon />
		</router-link>
		<div class="navigation">
			<featureSection :feature-name="'dashboard'" :show="false">
				<router-link active-class="active-link" class="btn btn-primary"
					:class="{ 'disabled-link': isProjectPaused || isMarketPaused }" to="/" data-cy="sb_dashboard_link"
					id="sb_dashboard_link" v-tooltip="t('dashboard.title')" @click.prevent="handleLinkClick">
					<dashboard_icon />
				</router-link>
			</featureSection>

			<featureSection :feature-name="'tasks'" :show="false">
				<router-link class="btn btn-primary" :class="{ 'disabled-link': isProjectPaused || isMarketPaused }"
					to="/tasks" data-cy="sb_tasks_link" id="sb_tasks_link" v-tooltip="t('tasks.title')"
					@click.prevent="handleLinkClick">
					<tasks_icon />
				</router-link>
			</featureSection>

			<featureSection :feature-name="'visibility'" :show="false">
				<router-link class="btn btn-primary" :class="{ 'disabled-link': isProjectPaused || isMarketPaused }"
					to="/visibility" data-cy="sb_visibility_link" id="sb_visibility_link"
					v-tooltip="t('visibility.title')" @click.prevent="handleLinkClick">
					<eyes_icon />
				</router-link>
			</featureSection>

			<featureSection :feature-name="'calendar'" :show="false">
				<router-link class="btn btn-primary" :class="{ 'disabled-link': isProjectPaused || isMarketPaused }"
					to="/calendar" data-cy="sb_calendar_link" id="sb_calendar_link" v-tooltip="t('calendar.title')"
					@click.prevent="handleLinkClick">
					<calendar_icon />
				</router-link>
			</featureSection>

			<featureSection :feature-name="'finder'" :show="false">
				<router-link class="btn btn-primary" :class="{ 'disabled-link': isProjectPaused || isMarketPaused }"
					to="/finder" data-cy="sb_finder_link" id="sb_finder_link" v-tooltip="t('finder.keywords_finder')"
					@click.prevent="handleLinkClick">
					<search_icon />
				</router-link>
			</featureSection>

			<featureSection :feature-name="'technical'" :show="false">
				<router-link class="btn btn-primary" :class="{ 'disabled-link': isProjectPaused || isMarketPaused }"
					to="/technical" data-cy="sb_technical_link" id="sb_technical_link" v-tooltip="t('technical.title')"
					@click.prevent="handleLinkClick">
					<!-- <technical_icon /> -->
					<!-- <img src="@/assets/icon/speedometer.svg" style="width: 1.8rem;"> -->
					<speedometer_icon />
				</router-link>
			</featureSection>

			<featureSection :feature-name="'text editor'" :show="false">
				<router-link active-class="active-link" class="btn btn-primary"
					:class="{ 'disabled-link': isProjectPaused || isMarketPaused }" to="/articles"
					data-cy="sb_article_link" id="sb_article_link" v-tooltip="t('articles.title')"
					@click.prevent="handleLinkClick">
					<edit_icon />
				</router-link>
			</featureSection>

			<featureSection :feature-name="'api'" :show="false">
				<router-link active-class="active-link" class="btn btn-primary"
					:class="{ 'disabled-link': isProjectPaused || isMarketPaused }" to="/api" data-cy="sb_api_link"
					id="sb_api_link" v-tooltip="t('api.title')" @click.prevent="handleLinkClick">
					<api_icon />
				</router-link>
			</featureSection>

			<featureSection :feature-name="'users'" :show="false">
				<router-link class="btn btn-primary" :class="{ 'disabled-link': isProjectPaused || isMarketPaused }"
					to="/users" data-cy="sb_users_link" id="sb_users_link" v-tooltip="t('comment_notifications.users')"
					@click.prevent="handleLinkClick">
					<users_icon />
				</router-link>
			</featureSection>

			<featureSection :feature-name="'clients'" :show="false">
				<router-link class="btn btn-primary" :class="{ 'disabled-link': isProjectPaused || isMarketPaused }"
					to="/clients" data-cy="sb_clients_link" id="sb_clients_link" v-tooltip="t('clients_admin.title')"
					@click.prevent="handleLinkClick">
					<clients_icon />
				</router-link>
			</featureSection>

			<featureSection :feature-name="'settings'" :show="false">
				<router-link class="btn btn-primary" :class="{ 'disabled-link': isProjectPaused || isMarketPaused }"
					to="/integration" data-cy="sb_settings_link" id="sb_settings_link" v-tooltip="t('settings.title')"
					@click.prevent="handleLinkClick">
					<setting_icon />
				</router-link>
			</featureSection>

			<featureSection :feature-name="'crawler-data'" :show="false">
				<router-link class="btn btn-primary" :class="{ 'disabled-link': isProjectPaused || isMarketPaused }"
					to="/crawler" data-cy="sb_crawler_link" id="sb_crawler_link" v-tooltip="t('crawler.title')"
					@click.prevent="handleLinkClick">
					<technical_icon />
				</router-link>
			</featureSection>

			<featureSection :feature-name="'log analyser'" :show="false">
				<router-link class="btn btn-primary" :class="{ 'disabled-link': isProjectPaused || isMarketPaused }"
					to="/log-analyzer" data-cy="sb_log_analyzer_link" id="sb_log_analyzer_link"
					v-tooltip="'Log Analyzer'" @click.prevent="handleLinkClick">
					<log_analyzer_icon />
				</router-link>
			</featureSection>
			<!--
      <featureSection :feature-name="'api'" :show="fa        <router-link class="btn btn-primary" to="/api" data-cy="sb_api_link" id="sb_api_link" v-tooltip="t('api.title')">
          <api_icon/>
        </router-link>
      </featureSection>
-->
		</div>
	</aside>
</template>

<script setup>
import { computed } from 'vue';
import { RouterLink, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/store/global/auth';
import { useMarketStore } from '@/store/global/market';
import logo_icon from '../icons/svg/logo_icon.vue';

import featureSection from '@/components/utilities/featureSection.vue';

import api_icon from '../icons/svg/api_icon.vue';
import clients_icon from '../icons/svg/clients_icon.vue';
import calendar_icon from '../icons/svg/calendar_icon.vue';
import dashboard_icon from '../icons/svg/dashboard_icon.vue';
import eyes_icon from '../icons/svg/eyes_icon.vue';
import search_icon from '../icons/svg/search_icon.vue';
import setting_icon from '../icons/svg/setting_icon.vue';
import tasks_icon from '../icons/svg/tasks_icon.vue';
import users_icon from '../icons/svg/users_icon.vue';
import technical_icon from '../icons/svg/technical_icon.vue';
import contentGuidance_icon from '../icons/svg/contentGuidance_icon.vue';
import speedometer_icon from '../icons/svg/speedometer_icon.vue';
import edit_icon from '../icons/svg/edit_icon.vue';
import log_analyzer_icon from '../icons/svg/log_analyzer_icon.vue';

import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const user = useAuthStore();
const router = useRouter();

const marketStore = useMarketStore();
const { projects, selectedProject, markets, selectedMarket } = storeToRefs(marketStore);

function getItemById(items, id) {
	return items.find(item => item.id === id) || null;
}

const selectedProjectItem = computed(() => getItemById(projects.value, selectedProject.value));
const selectedMarketItem = computed(() => getItemById(markets.value, selectedMarket.value));
const isProjectPaused = computed(() => selectedProjectItem.value?.type === 'paused');
const isMarketPaused = computed(() => selectedMarketItem.value?.type === 'paused');

function handleLinkClick(event) {
	if (isProjectPaused.value || isMarketPaused.value) {
		event.preventDefault();
		event.stopPropagation();
		event.stopImmediatePropagation();
		return false;
	}
}
</script>

<style lang="scss" scoped>
.disabled-link {
	cursor: not-allowed;
	pointer-events: none;
	opacity: 0.7;
}
</style>
